exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Tags__tagSurround___3LdBk {\n    position: relative;\n    box-sizing: border-box;\n    height: 100%;\n    width: 100%;\n    /*\tPrevents the user from selecting text instead of dragging */\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.Tags__fadeIcon___2Rejd {\n    opacity: 0;\n    position: absolute;\n    bottom: 1rem;\n    left: 1rem;\n    animation: Tags__fade___hFngd 6s linear forwards;\n    width: 2rem;\n    height: 2rem;\n}\n\n.Tags__icon___33No9 {\n    box-shadow: 0px 0px 10px rgba(0,0,0,0.5);\n    border-radius: 100%;\n    background-color: #555;    \n}\n\n@keyframes Tags__fade___hFngd {\n    0% { opacity: 0 }\n    25% { opacity: 1 }\n    75% { opacity: 1 }\n    100% { opacity: 0; display: none; }\n}\n\n.Tags__tagSurround___3LdBk:focus { outline: 0; }\n\n.Tags__tag___1jMmy {\n    z-index: 2;\n    position: absolute;\n}\n\n.Tags__invisibleTag___2wWAu {\n    visibility: hidden\n}\n\n.Tags__fadeTag___1G4sz {\n\topacity: 1;\n\tanimation-name: Tags__fadeInOpacity___LXyna;\n\tanimation-iteration-count: 1;\n\tanimation-timing-function: ease-in;\n\tanimation-duration: 0.4s;\n}\n\n@keyframes Tags__fadeInOpacity___LXyna {\n\t0% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n", ""]);

// exports
exports.locals = {
	"tagSurround": "Tags__tagSurround___3LdBk",
	"fadeIcon": "Tags__fadeIcon___2Rejd",
	"fade": "Tags__fade___hFngd",
	"icon": "Tags__icon___33No9",
	"tag": "Tags__tag___1jMmy",
	"invisibleTag": "Tags__invisibleTag___2wWAu",
	"fadeTag": "Tags__fadeTag___1G4sz",
	"fadeInOpacity": "Tags__fadeInOpacity___LXyna"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/Tags.icss
// module id = 1460
// module chunks = 0